import type { ExtensionInventoryRow } from "@whatslly/types/integrations/BrowserExtensionInventory";

export interface IExtensionsStore {
  extensions: ExtensionInventoryRow[];
  extensionsLoading: boolean;
  /** Devices that have ever reported an `extensions` field; 0 = discovery not running yet. */
  reportingDeviceCount: number;
  loadExtensions(): Promise<void>;
  /** Adds a manually-tracked extension (not driven by policy/discovery). Reloads the inventory on success. */
  addManual(id: string, name?: string, notes?: string): Promise<boolean>;
  /** Updates a manually-tracked extension's name/notes. Reloads the inventory on success. */
  updateManual(id: string, name?: string, notes?: string): Promise<boolean>;
  /** Removes a manually-tracked extension. Reloads the inventory on success. */
  deleteManual(id: string): Promise<{ ok: boolean; blockedBy?: string[] }>;
  /** Looks up display metadata (name/icon) for an extension id from the Chrome Web Store. */
  resolve(id: string): Promise<{ name?: string; iconUrl?: string }>;
}

export const InjectExtensionsStore = Symbol.for("IExtensionsStore");
